import { defineStore } from 'pinia'
import { deviceService } from '@/services/deviceService.ts'
import { ref } from 'vue'
import { prepareSort } from '@/assets/js/main.ts'

export const useDeviceStore = defineStore('device', () => {
  const device = ref()

  async function get(id: any) {
    device.value = await deviceService.show(id)
  }

  async function getItems(
    page: number,
    perPage: number,
    sortParams?: { field: string; order: number | string } | null,
    searchField?: null,
    filterScopes?: Map<string, string>,
    endpoint?: string | null
  ) {
    return await deviceService.index(
      page,
      perPage,
      prepareSort(sortParams),
      searchField,
      filterScopes,
      endpoint
    )
  }

  async function manage(params: any, id: any) {
    await deviceService.manage(params, id)
  }

  async function getItemsForSelect() {
    return (await deviceService.getDevicesForSelect()).data
  }

  async function deleteItem(id: any) {
    return await deviceService.delete(id)
  }

  return {
    device,
    get,
    getItems,
    manage,
    getItemsForSelect,
    deleteItem
  }
})
